Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.URLRequestMethod = module.exports.default = {
	DELETE: "DELETE",
	GET: "GET",
	HEAD: "HEAD",
	OPTIONS: "OPTIONS",
	POST: "POST",
	PUT: "PUT"
};